
import { Component, Prop, VModel, Vue } from 'nuxt-property-decorator'
import { NeoField, NeoInput } from '@kodadot1/brick'

@Component({
  components: {
    NeoField,
    NeoInput,
  },
})
export default class BasicNumberInput extends Vue {
  // Dev: make vValue required
  @VModel({ type: Number }) vValue!: number
  @Prop({ type: String, required: true }) label!: string
  @Prop({ type: String, required: false }) placeholder!: string
  @Prop({ type: Boolean, default: false }) expanded!: boolean
  @Prop({ type: String }) message!: string
  @Prop({ type: Number, required: false }) max!: number
  @Prop({ type: Number, required: false, default: 1 }) min!: number
  @Prop({ type: Number, required: false, default: 1 }) step!: number
  @Prop({ type: Number, required: false }) minStep!: number

  public hasFocus = false
}
